import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import LanguageIcon from '@material-ui/icons/Language';

const styles = theme => ({
    rowIconButtonRoot: {
        height: 40
    }
});

class WebsiteComponent extends React.Component {
    render() {
        const { website, children, columns, colSpan } = this.props;
        return (
            <React.Fragment>
                <TableRow selected>
                    <TableCell className="icon-cell"><LanguageIcon /></TableCell>
                    {
                        columns &&
                        [].concat(columns).map((col, colIndex) => <TableCell colSpan={colSpan} key={`table_row_${website.id}_cell_${colIndex}`}>{website[col.field]}</TableCell>)
                    }
                    {
                        <TableCell numeric></TableCell>
                    }
                </TableRow>
                {children}
            </React.Fragment>
        );
    }
}

WebsiteComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired
}

export default withStyles(styles)(WebsiteComponent);


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/MediaPlan/WebsiteComponent.js